import { z } from "zod";

const translationPath = "page.4uDlist.listClassification.errors.";

export const listClassificationSchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  name: z
    .string()
    .trim()
    .min(1, translationPath + "name"),
  description: z.string().nullish(),
  code: z.number().optional(),
});

export type TListClassificationForm = z.infer<typeof listClassificationSchema>;
